import { z } from 'zod';

/**
 * The Bizy profile endpoint intentionally does NOT use the `Key-Inflection: camel`
 * header so that field names round-trip cleanly: the server-driven `required_fields`
 * list contains the exact snake_case keys that appear inside `fields` and that the
 * client must send back in the PATCH body. This keeps the contract additive — when
 * the backend adds a new field to `PROFILE_FIELDS`, no FE change is needed.
 */
export const BizyProfile = z.object({
	fields: z.record(z.string(), z.string().nullable()),
	required_fields: z.array(z.string()),
	required_complete: z.boolean(),
});

export type BizyProfile = z.infer<typeof BizyProfile>;

/** Stable machine-readable reasons returned in PATCH error responses. */
export const BizyProfileErrorReason = z.enum(['invalid_field', 'too_long', 'rejected']);

export type BizyProfileErrorReason = z.infer<typeof BizyProfileErrorReason>;

export const bizyProfileFixture = (overrides: Partial<BizyProfile> = {}): BizyProfile => ({
	fields: { bizy_nickname: 'Danny', job_title: 'Engineer' },
	required_fields: ['bizy_nickname', 'job_title'],
	required_complete: true,
	...overrides,
});
